<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable
                        @change="handleStoreChange">
                        <el-option v-for="item in storeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编号：">
                    <el-input v-model="formInline.code" placeholder="请输入申购单编号" clearable size="small"></el-input>
                </el-form-item>
                <el-form-item label="申请时间：">
                    <el-date-picker clearable v-model="dateRange" size="small" type="daterange"
                        value-format="yyyy-MM-dd" format="yyyy年MM月dd日" @change="handleDateChange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="申购类型：">
                    <el-select v-model="formInline.state" placeholder="请选择申购类型" clearable size="small" filterable>
                        <el-option v-for="item in stateList" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="btnPermission.search" size="small"
                        type="primary" class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                    <el-button v-if="btnPermission.create" size="small"
                        type="primary" class="el-icon-plus" @click="handleEditClick()">
                        新增
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" :loading="loading" @rowDBClick="handleEditClick" border
                stripe row-key="keyId">
                <el-table-column slot="code" label="申购单编号" min-width="220" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="handleDetailClick(scope.row)">
                            {{ scope.row.code }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column slot="goodsCount" label="商品总数量" min-width="120" align="center">
                    <template slot-scope="scope">
                       <el-link v-if="scope.row.goodsCount > 0 && btnPermission.returnQty && scope.row.state == 7" type="primary" :underline="false" @click="handleReturnQtyClick(scope.row)">
                            {{ scope.row.goodsCount }}
                        </el-link>
                        <span v-else>{{ scope.row.goodsCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column slot="stateStr" label="申购状态" min-width="120" align="center" fixed="left">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.state == 1">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.state == 2">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="danger" v-else-if="scope.row.state == 8">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="info" v-else-if="scope.row.state == 3">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.state == 4">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.state == 5">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.state == 6">{{ scope.row.stateStr }}</el-tag>
                        <el-tag type="success" v-else>{{ scope.row.stateStr }}</el-tag>
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
        <!-- 编辑 -->
        <edit ref="edit" :storeList="storeList"></edit>
        <!-- 详情 -->
        <detail ref="detail" :storeList="storeList"></detail>
        <!-- 选择商品类型 -->
        <selectProductType ref="selectProductType"></selectProductType>
        <!-- 退货数量 -->
        <returnQty ref="returnQty"></returnQty>
    </div>
</template>

<script>
import {
    GetStoreSubscriptionPageList,
} from "@/api/productApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import edit from './edit.vue'
import detail from './detail.vue'
import selectProductType from '@/views/product/type/selectProductType.vue'
import returnQty from './returnQty.vue'
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "门店申购单",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                state: 0,
                code: "",
                startTime: null,
                endTime: null,
            },
            columnsData: [],
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "createTime",
                    label: "申购时间",
                    width: "170",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "creator",
                    label: "申购人",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "storeName",
                    label: "申购门店",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    slot: "stateStr",
                    label: "申购状态",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    slot: "code",
                    label: "申购单号",
                    isKeep: true,
                    minWidth: "170",
                    align: "center",
                },
                {
                    prop: "goodsTypeCount",
                    label: "类型数量",
                    width: "120",
                    align: "center",
                },
                {
                    slot: "goodsCount",
                    label: "商品总数量",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "kdNo",
                    label: "快递单号",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "purchaseUserName",
                    label: "采购人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "purchaseDate",
                    label: "采购确认时间",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "审核人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "confirmDate",
                    label: "审核时间",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "payUserName",
                    label: "支付人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "payDate",
                    label: "支付时间",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "remark",
                    label: "备注",
                    width: "220",
                    align: "center",
                },
                {
                    prop: "editor",
                    label: "维护人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "updateTime",
                    label: "维护时间",
                    width: "170",
                    align: "center",
                },
            ],
            storeList: [],
            stateList: [],
            dateRange: [],
            btnPermission: {
                search: false,
                create: false,
                returnQty: false,
            },
        };
    },
    // 注册组件
    components: {
        edit,
        detail,
        selectProductType,
        returnQty,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.GetOrgInfoListByConfig();
        this.GetEnumConfigListByCode();
        this.getListData();
        // 按钮权限
        this.btnPermission = {
            search: this.$checkBtnPermission('/subscription/index', 'viewPage'),
            create: this.$checkBtnPermission('/subscription/index', 'create'),
            returnQty: this.$checkBtnPermission('/subscription/index', 'returnQty'),
        }
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取列表
        getListData() {
            this.loading = true;
            GetStoreSubscriptionPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange() {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 点击事件
        handleEditClick(row) {
            this.$refs.edit.showEdit(row);
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        //获取状态信息
        GetEnumConfigListByCode() {
            const paramer = {
                code: "StoreSubscriptionState",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.stateList = [];
                        res.data.forEach((item) => {
                            this.stateList.push({
                                code: parseInt(item.code),
                                name: item.name,
                            });
                        });
                        this.stateList.unshift({
                            code: 0,
                            name: "全部",
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取状态信息失败!");
                });
        },
        handleDateChange(val) {
            if (val) {
                this.formInline.startTime = val[0];
                this.formInline.endTime = val[1];
            } else {
                this.formInline.startTime = null;
                this.formInline.endTime = null;
            }
            this.search();
        },
        // 门店选择事件
        handleStoreChange(val) {
            this.formInline.storeKeyId = val;
            this.search();
        },
        // 商品类型选择事件
        handleProductTypeChange(val) {
            this.$refs.edit.ChooseProductType(val);
        },
        //展示商品类型选择弹窗
        showProductTypeSelect(val) {
            this.$refs.selectProductType.showSelectProductTypeDialog(val, true);
        },
        // 详情
        handleDetailClick(row) {
            this.$refs.detail.showDetail(row.keyId, 1);
        },
        // 点击事件
        handleReturnQtyClick(row) {
            this.$refs.returnQty.showReturnQty(row.keyId);
        },
    },
};
</script>

<style scoped></style>